import DropdownMenu from './DropdownMenu'
import DropdownMenuTrigger from './DropdownMenuTrigger'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class DropdownActions extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    direction: PropTypes.oneOf(['left', 'right'])
  }

  static defaultProps = {
    direction: 'left'
  }

  render() {
    const { children, direction } = this.props

    return (
      <div className="btn-group">
        <DropdownMenuTrigger text="Actions" />
        <DropdownMenu direction={direction}>{children}</DropdownMenu>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/DropdownActions.js